export const STEP_IDENTIFIER_NAME = {
	AI_ASK_CHOICE: 'ai_ask_choice',
	AI_DESCRIPTION: 'ai_description',
	AI_PROMPT: 'ai_prompt',
	AI_RESULTS_DRAFT: 'ai_results_draft',
	ASK: 'ask',
	DESCRIPTION: 'description',
	LOCATION: 'location',
	MEDIA: 'media',
	PHONE_COLLECTION: 'phone_collection',
	PUBLISH: 'publish',
	REACH: 'reach',
};
